import React from 'react';
import { Button } from '../ui/button';
import { format, addDays, subDays } from 'date-fns';
import { ChevronLeft, ChevronRight, RefreshCw, CalendarDays, CheckSquare, FileSpreadsheet } from 'lucide-react';

function ScheduleToolbar({ startDate, onDateChange, dates, workCenters, isLoading, onRefresh, onDailySettle, onExport }) {
  const endDate = dates[dates.length - 1];

  return (
    <div className="flex items-center justify-between px-4 py-3 border-b bg-white shrink-0">
      <div className="flex items-center gap-3">
        <h1 className="text-lg font-semibold text-gray-900">生产排程看板</h1>
        <div className="flex items-center gap-1">
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={() => onDateChange(subDays(startDate, 1))}
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <div className="flex items-center gap-1 px-2 py-1 bg-gray-100 rounded-md text-sm text-gray-700">
            <CalendarDays className="h-3.5 w-3.5" />
            <span>
              {format(startDate, 'MM/dd')} - {format(endDate, 'MM/dd')}
            </span>
          </div>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={() => onDateChange(addDays(startDate, 1))}
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
        <Button
          variant="outline"
          size="sm"
          className="h-8 text-xs"
          onClick={() => onDateChange(new Date())}
        >
          今天
        </Button>
      </div>

      <div className="flex items-center gap-2">
        <div className="text-xs text-gray-500 mr-2">
          设备: {workCenters.length} | 日期: {dates.length}天
        </div>
        <Button
          variant="outline"
          size="sm"
          className="h-8 text-xs"
          onClick={onRefresh}
          disabled={isLoading}
        >
          <RefreshCw className={`h-3.5 w-3.5 mr-1 ${isLoading ? 'animate-spin' : ''}`} />
          刷新
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="h-8 text-xs"
          onClick={() => onDailySettle(startDate)}
        >
          <CheckSquare className="h-3.5 w-3.5 mr-1" />
          结算当日
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="h-8 text-xs"
          onClick={onExport}
        >
          <FileSpreadsheet className="h-3.5 w-3.5 mr-1" />
          导出计划
        </Button>
      </div>
    </div>
  );
}

export default ScheduleToolbar;
